
import Vue from 'vue'

/**
 * @author Suhipney R. <suhiipney@gmail.com>
 *
 * @param user user to delete
 *
 *  @return {Object} Deleted
 */

export default (user) =>
  Vue.$http.delete(`/users/${user.username}/`)
    .then(({ data }) => data)
